export const GetDropDownValue = (options, value, includeSubHeader = false) => {
  let result =
    options.find((g) => g.value === value)?.label ||
    options.find((g) => g.value === value)?.header ||
    value;
  if (includeSubHeader) {
    const subResult =
      options.find((g) => g.value === value)?.subLabel ||
      options.find((g) => g.value === value)?.subHeader;
    result += subResult ? ` (${
      options.find((g) => g.value === value)?.subLabel ||
      options.find((g) => g.value === value)?.subHeader
    })` : "";
  }
  return result;
};

export const GetMultiDropDownValue = (options, value) => {
  if (!value) return "n/a";

  const values = value?.split(",")?.map((v) => v.trim());
  const matchedValues = values
    .map(
      (val) =>
        options.find((opt) => opt.value === val)?.header ||
        options.find((opt) => opt.value === val)?.label
    )
    .filter((v) => v !== undefined);

  return matchedValues.length > 0 ? matchedValues.join(", ") : "n/a";
};
